import React from "react";
import style from "./Checkbox.module.scss";

const CheckBox = (props) => {
    return (
        <div className={style.wrapper}>
            <label
                className={style.CheckBoxContainer}
            >
                <input
                    type="checkbox"
                    checked={props.value && !props.indeterminate ? 'checked' : ''}
                    onChange={e => props.onclick(e, props.value, props.tag, props.secondTag)}
                    disabled={props.disabled ? props.disabled : false}
                ></input>
                <span className={props.indeterminate ? style.indeterminateCheckmark : style.checkmark}></span>
            </label>
            {props.label ? <p className={style.checkboxLabel}>
                {props.label}
                {props.lineThrough && <div className={style.line}></div>}
            </p> : ''}
        </div>
    );
}

export default CheckBox;

/**
 value={checkbox}
 indeterminate={true}
 tag='فیلتر'
 label='اعمال فیلتر'
 onclick={handleCheckBox}
 */